import { useActivitiesStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreActivitiesComponent } from "@b2bportal/core-types";
import {
  Calendar,
  DatePickerButton,
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
  PickerType,
} from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./DateRangePicker.module.scss";
import {
  useDateRangePicker,
  type DateRangePickerComponentProps,
} from "./hooks";

export type { DateRangePickerComponentProps };

export const DateRangePicker = (props: DateRangePickerComponentProps) => {
  const COMPONENT_KEY = CoreActivitiesComponent.DateRangePicker;
  const styles = useActivitiesStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context, handlers, text } = useDateRangePicker(props);

  return (
    <Dialog onClose={handlers.onClose} onOpen={handlers.onOpen}>
      <DialogTrigger asChild>
        {props.triggerButton ?? (
          <DatePickerButton
            startDate={context.stringStartDate}
            endDate={context.stringEndDate}
            startLabel={text.selectDatesLabel}
            endLabel={text.selectDatesLabel}
            hideEndDate
            collectiveDate
            placeholder={text.placeholder}
            error={context.error}
          />
        )}
      </DialogTrigger>
      <DialogContent
        title={text.dialogTitle}
        className={clsx(cn("dialog-content"), props.classNames?.content)}
        fullScreen={context.dialogFullscreen}
        bottomFixedContent={
          <div className={cn("bottom-content")}>
            <DialogClose asChild>
              <button
                className={cn("apply-button")}
                onClick={handlers.onDoneClick}
              >
                {text.dialogDone}
              </button>
            </DialogClose>
          </div>
        }
      >
        <Calendar
          className={cn("calendar")}
          viewType={context.calendarViewType}
          setStartDate={handlers.onStartDateChange}
          setEndDate={handlers.onEndDateChange}
          startDate={context.startDate}
          endDate={context.endDate}
          startDateLabel={text.selectDatesLabel}
          endDateLabel={text.selectDatesLabel}
          pickerType={PickerType.RANGE}
          priceTagsElement={<></>}
          months={[]}
          currency={""}
          priceTags={[]}
        />
      </DialogContent>
    </Dialog>
  );
};
